module.exports = __webpack_public_path__ + "static/media/trashcan512x512.596404b1.png";